module.exports = __webpack_public_path__ + "img/clock1.b097ea69.svg";